import { useEffect } from 'react';
import clsx from 'clsx';
import { isEmpty } from 'lodash-es';
import { AText, Box, Overlay } from '@alf/uikit';
import { CommonLoader, useIsNavMenuVisible } from '@namespace/common';
import { useI18n } from '@namespace/i18n';
import { PersonalOfficeWrapper } from '../../../../account';
import { bonusesActions } from '../../store';
import AcceptBonus from '../AcceptBonusButton';
import BonusCountdownTimer from '../BonusCountdownTimer';
import { BonusProgressDetails } from '../BonusProgressDetails';
import StatusLabel from '../StatusLabel';
import WagerProgressBar from '../WagerProgressBar';

import styles from './index.module.css';

const { RESET_BONUS_DETAILS } = bonusesActions;

const CrmBonusDetails = ({
  bonus,
  status,
  onAccept,
  isActivation,
  isRequestProcessing,
  isFetchingDetails
}) => {
  const { t, f } = useI18n();
  const {
    bonusDescription,
    bonusModelId,
    bonusDetailsList,
    isShowButton,
    progressBarStatus,
    countdownTimerTitle,
    isCountdownTimerEnabled,
    expireTime,
    buttonType,
    bonusName,
    isWagerEnabled,
    isShowWagerButton
  } = bonus;
  const navMenuVisible = useIsNavMenuVisible();

  useEffect(() => {
    return () => {
      RESET_BONUS_DETAILS();
    };
  }, []);

  if (isFetchingDetails) {
    return (
      <Overlay>
        <CommonLoader />
      </Overlay>
    );
  }

  return (
    <Box component={PersonalOfficeWrapper} direction="column" justify="between">
      <Box direction="column" className={styles.mainContent}>
        <div className={styles.statusLabel}>
          <StatusLabel
            status={status}
            className={styles.statusLabelItem}
            textSize="s"
          />
        </div>
        <AText
          breed="BU"
          size="xl"
          color="po_txt_color_1"
          className={styles.title}
        >
          {t(`content.bonus.template.name.${bonusModelId}`, bonusName)}
        </AText>
        <BonusProgressDetails
          detailsList={bonusDetailsList}
          className={styles.bonusDetails}
        />
        {isCountdownTimerEnabled && expireTime?.ms && (
          <BonusCountdownTimer
            time={expireTime.ms - f.getDateTime().toMillis()}
            title={countdownTimerTitle}
            className={styles.countdownTimer}
          />
        )}
        <WagerProgressBar
          bonus={bonus}
          status={progressBarStatus}
          isWagerEnabled={isWagerEnabled}
        />
        {!isEmpty(bonusDescription) && !isFetchingDetails && (
          <>
            <AText
              breed="BU"
              size="m"
              color="po_txt_color_1"
              className={styles.descriptionTitle}
            >
              {t('web.personaloffice.bonuses.description')}
            </AText>
            <div
              className={styles.content}
              dangerouslySetInnerHTML={{ __html: bonusDescription }}
            />
          </>
        )}
      </Box>
      {isShowButton && (
        <Box
          className={clsx(
            styles.acceptButtonContainer,
            navMenuVisible && styles.withNavMenu
          )}
        >
          <AcceptBonus
            fullWidth={true}
            className={styles.acceptButton}
            status={status}
            onClick={onAccept}
            title={t(`web.personaloffice.bonuses.button.${buttonType}`)}
            isActivation={isActivation}
            isRequestProcessing={isRequestProcessing}
            intent={isShowWagerButton ? 'secondary' : 'primary'}
          />
        </Box>
      )}
    </Box>
  );
};

export default CrmBonusDetails;
